<!-- <label class="close_button" (click)="closeDialog()">x</label> -->
<button class="close" (click)="closeDialog()">
	<mat-icon>close</mat-icon>
</button>
<div class="uploadTemplateFile">
	<div class="divFile">
		<div draggable="true" ngClass="{{dragAreaClass}}" class="custom-dropzone">
			<!-- <input id="fileInput" type="file" accept=".xls, .xlsx, .csv" (click)="onClick($event)"
				(change)="fileChange($event)" #fileInput style="display:none" /> -->
				<input id="fileInput" type="file" accept=".xls, .xlsx, .csv" (click)="onClick($event)"
				(change)="onFileSelected($event)" #fileInput style="display:none" />
			<mat-icon id="cloudUpload" class="mat-icon material-icons upload-icon" aria-hidden="true">
				cloud_upload
			</mat-icon>
			<p id="dragDrop" *ngIf="!templateFile" class="dragdrop">Drag and Drop to Upload (or) </p>
			<p *ngIf="templateFile" class="dragdrop">{{templateFile.name}}</p>
			<label for="fileInput" class="btnFile">BROWSE FILE</label>
		</div>
		<!-- <button mat-raised-button class="btnImport" style="display: inline;" (click)="importFile()">
			Import
		</button> -->
		<button mat-raised-button class="btnImport" style="display: inline;" (click)="newimportFile()">
			IMPORT
		</button>
	</div>
	<div *ngIf="successMessage" class="alert alert-success" role="alert" style="margin-top: 2%">
		<mat-icon>thumb_up</mat-icon> &nbsp;
		<label style="vertical-align: text-bottom; margin-bottom: 0rem;">
			{{successMessage}}
		</label>
	</div>
	<div *ngIf="errorMessage" class="alert alert-danger" role="alert" style="margin-top: 2%">
		<label style="vertical-align: text-bottom; margin-bottom: 0rem;">
			{{errorMessage}}
		</label>
	</div>
	<div class="grid-agg">
		<ag-grid-angular #agGrid style="width: 100%; height: 350px;" id="uploadTemplateGrid" class="ag-theme-balham"
			[columnDefs]="columnDefs" [rowData]="rowData" (gridReady)="onGridReady($event)" (window:resize)="sizeToFit()"[theme]="'legacy'"
			[gridOptions]="gridOptions" [context]="context" [enableCellTextSelection]="true" [ensureDomOrder]="true" >
		</ag-grid-angular>
	</div>
</div>
<div class="cfooter d-flex justify-content-between align-items-center popup-footer">
	<button (click)="closeDialog()" class="mCancel"> CANCEL
	</button>
</div>